/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Queuetemplates1Inputs */

const en_entity_queuetemplates1 = /** @type {(inputs: Entity_Queuetemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Templates`)
};

const de_entity_queuetemplates1 = /** @type {(inputs: Entity_Queuetemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen`)
};

/**
* | output |
* | --- |
* | "Queue Templates" |
*
* @param {Entity_Queuetemplates1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_queuetemplates1 = /** @type {((inputs?: Entity_Queuetemplates1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Queuetemplates1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_queuetemplates1(inputs)
	return de_entity_queuetemplates1(inputs)
});
export { entity_queuetemplates1 as "entity_queueTemplates" }